import { queryClient } from "@/queryClient"
import { api } from "@/api"

export type CreateCategoryQuery = {
  name: string
  parentCategoryId: string | null
  color: string | null
}

export const createCategory = async (
  params: CreateCategoryQuery
) => {
  await api.post("/products/categories/", {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [BASE_CATEGORIES_QUERY_KEY],
  })
  return
}
